'use client';

import type { FeatureFlagName } from '@/libs/feature-flags/flags';
import { useFlag } from '@unleash/nextjs/client';
import { getFeatureFlagOverride } from '@/libs/feature-flags/overrides';

export function useFeatureFlag(flag: FeatureFlagName): boolean {
  const isEnabled = useFlag(flag);

  return getFeatureFlagOverride(flag) ?? isEnabled;
}
